/* eslint-disable no-shadow */
import { useEffect, useState, useRef } from 'react';
import { db } from 'codemash';
import { Config } from 'configs';
import { apiActionChooser } from 'utils/apiActionChooser';
import { resourceRequest } from 'api/client/requests';
import { useStateWithCallbackLazy } from './useStateWithCallback';

export const useAggregate = ({
  secretKey,
  collectionName,
  aggregateId,
  filter,
  pageSize,
  pageNumber,
  sort,
  projection,
  refresher,
  formatResult,
  dontRunOnInit,
  loadOnInit,
  filterBuilder,
  sortBuilder,
  onResponse,
  onResult,
  aggregateIdV2,
  companyIdForV2,
}) => {
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(loadOnInit
    ? Config.DATA.LOADING_STATUS.INITIAL_LOAD
    : Config.DATA.LOADING_STATUS.NOT_LOADING);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // const [noMoreResults, setNoMoreResults] = useState(false);
  // const [totalGot, setTotalGot] = useState(0);
  // const [totalUnshifted, setTotalUnshifted] = useState(0);
  // const [hasCalled, setHasCalled] = useState(false);
  // const totalRefreshes = useRef({ value: 0 }).current;
  const [requestData, setRequestData] = useStateWithCallbackLazy({
    aggregateId,
    aggregateIdV2,
    collectionName,
    filter,
    pageSize,
    pageNumber: pageNumber || 0,
    sort,
    projection,
    refresher,
    filterBuilder,
    sortBuilder,
    companyIdForV2,
  });

  const find = async (refresh, customRequestData, tokenReplacements) => {
    // console.log('Pyrst', refresh, customRequestData);
    // if ((refresh && isRefreshing) || (!refresh && (noMoreResults || isLoading !== 0))) {

    // if ((refresh && isRefreshing) || (!refresh && isLoading !== 0)) {
    //   return;
    // }

    const requestDataToUse = customRequestData || requestData;

    /*
    console.log('--- CodeMash Aggregate --- ');
    console.log('1. CollectionName', requestDataToUse.collectionName);
    console.log('2. Filter', requestDataToUse.filter);
    console.log('3. PagingOptions', requestDataToUse.pageSize, requestDataToUse.pageNumber);
    console.log('4. SortOptions', requestDataToUse.sort);
    console.log('5. Projection', requestDataToUse.projection);
    console.log('--------------------- '); */

    try {
      if (isLoading !== Config.DATA.LOADING_STATUS.INITIAL_LOAD) {
        setIsLoading(Config.DATA.LOADING_STATUS.PAGING_LOAD);
      }

      if (refresh) {
        setIsRefreshing(true);
      }

      let tokens = {
        skip: refresh
          ? 0
          : (requestDataToUse.pageNumber || 0) *
            (requestDataToUse.pageSize || Config.DEFAULTS.PAGE_SIZE), // +
        // totalUnshifted,
        pageSize: requestDataToUse.pageSize || Config.DEFAULTS.PAGE_SIZE,
        sort: sortBuilder ? sortBuilder() : requestDataToUse.sort,
        ...(filterBuilder ? filterBuilder() : requestDataToUse.filter || {}),
        projection: requestDataToUse.projection,
      };

      if (tokenReplacements) {
        tokens = { ...tokens, ...tokenReplacements };
      }

      // const response = await db.executeAggregate({
      //   secretKey,
      //   database: Config.CODEMASH.DATABASE_ID,
      //   id: requestDataToUse.aggregateId,
      //   collectionName: requestDataToUse.collectionName,
      //   tokens,
      // });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.executeAggregate({
          secretKey,
          database: Config.CODEMASH.DATABASE_ID,
          id: requestDataToUse.aggregateId,
          collectionName: requestDataToUse.collectionName,
          tokens,
        });
      }, async () => {
        response = await resourceRequest({
          data: {
            id: requestDataToUse.aggregateIdV2,
            tokens,
          },
          action: 'aggregate',
        });
      });

      // let newTotalGot = 0;
      let formedResult = [];

      if (formatResult) {
        formedResult = formatResult(response);
      } else {
        formedResult = response || [];
      }

      if (onResponse) {
        await onResponse(formedResult);
      }

      // if (refresh) {
      //   setResult([...formedResult]);

      //   newTotalGot = formedResult.length;
      //   setTotalGot(newTotalGot);

      //   if (totalUnshifted > 0) {
      //     setTotalUnshifted(0);
      //   }
      // } else {
      //   setResult([...result, ...formedResult]);

      //   newTotalGot = totalGot + formedResult.length;
      //   setTotalGot(newTotalGot);
      // }
      setResult([...formedResult]);

      // if (requestDataToUse.pageSize > formedResult.length) {
      //   setNoMoreResults(true);
      // } else {
      //   setNoMoreResults(false);
      // }
      // }

      // setNextPage(nextPage + 1);
      // setRequestData((prevData) => ({
      //   ...prevData,
      //   pageNumber: refresh ? 1 : prevData.pageNumber + 1,
      // }));
    } catch (e) {
      console.log('Error occured during the aggregate', e);
      setErrorMessage('tr Something went wrong');
    } finally {
      setIsRefreshing(false);

      // if (!hasCalled) {
      //   setHasCalled(true);
      // }

      // setIsLoading(0);
      setIsLoading(Config.DATA.LOADING_STATUS.NOT_LOADING);

      if (onResult) {
        onResult();
      }
    }
  };

  useEffect(() => {
    if (!dontRunOnInit) {
      find();
    }
  }, []);

  // useEffect(() => {
  //   if (requestData.refresher !== refresher) {
  //     setRequestData(
  //       {
  //         aggregateId,
  //         collectionName,
  //         filter,
  //         pageSize,
  //         pageNumber: pageNumber || 0,
  //         sort,
  //         projection,
  //         refresher,
  //       },
  //       (currentData) => {
  //         find(true, currentData);
  //       },
  //     );
  //   }
  // }, [refresher]);

  // return [find, result, isLoading, errorMessage, noMoreResults, isRefreshing, hasCalled];
  return [find, result, isLoading, errorMessage, setIsLoading, isRefreshing];
};
